var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefinitiv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 40,
    viewBox: "0 0 198 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.752 40h-6.348l-22.199-22.198h25.374v4.44h-14.586L197.752 40zm-3.176-40h-40v40h4.447V4.443h35.553V0z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.834 29.863h3.939L10.4 21l.147-.043c2.291-.652 3.58-2.481 3.562-5.013-.032-3.684-2.316-5.796-6.265-5.796H0v19.728h3.58v-8.15h3.506l3.748 8.139v-.002zM3.58 18.884V12.98h3.617c2.201 0 3.369 1.02 3.369 2.954 0 2.094-1.171 2.95-4.032 2.95H3.58zm25.743 2.18V18.11H22.47v-5.013h9.395v-2.96H18.908v19.727h13.276V26.91H22.47v-5.847h6.853v.001zm17.938-2.953h-6.66v-5.013h8.912v-2.96H37.04v19.727h3.58v-8.8h6.642V18.11l-.001.001zm6.513-7.974v19.728h3.562V10.136h-3.562v.001zm30.866 0v19.728h3.563V10.136H84.64v.001zm21.94 0H92.568v2.954h5.231v16.774h3.58V13.09h5.231l-.028-2.954-.002.001zm4.33 0v19.728h3.562V10.136h-3.563l.001.001zm-35.625 0v13.981h-.054l-8.067-13.963h-3.773v19.728h3.34V15.274h.054l4.404 7.68 3.967 6.91h3.48V10.136h-3.351v.001zm56.058 0l-4.598 16h-.032l-4.622-16h-3.49l6.086 19.728h4.07l6.087-19.728h-3.501z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinitiv);
export default __webpack_public_path__ + "static/media/Refinitiv.c8e5cfaba82d62324a50b3dd5c49f4c1.svg";
export { ForwardRef as ReactComponent };